<template>
  <sdui-alert
    variant="info-inverted"
    alert-class="pl-0 pr-4 py-4"
    align-icon="top"
    icon-class="pt-4"
    :action-class="[
      'px-4 pb-4 justify-content-end',
      { 'flex-column align-items-end': isConfigureInfoCard, 'align-items-center': !isConfigureInfoCard },
    ]"
    :display-action-as-full-row="true"
  >
    <template #title>
      <h2 class="fz-base gray-400 font-weight-normal mb-2" data-cy="content-move-card-title">{{ title }}</h2>
    </template>

    <template #content>
      <div data-cy="content-move-card-description">
        <slot v-if="$hasSlotContent($slots['content'])" name="content" />
        <div v-else class="f-14 gray-300 font-weight-light m-0">
          <p>{{ $t(cardCaptions.description_1_path) }}</p>
          <template v-if="hasSuggestedChannel">
            <i18n-t :keypath="cardCaptions.description_2_path" tag="p">
              <template #description_2_subtext1>
                <span class="font-weight-bold black">
                  {{ $t(cardCaptions.description_2_subtext1_path) }}
                </span>
              </template>
              <template #description_2_subtext2>
                <i18n-t :keypath="cardCaptions.description_2_subtext2_path"
                        tag="span"
                        class="font-weight-bold black"
                >
                  <template #groupName>
                    {{ cardCaptions.groupName }}
                  </template>
                </i18n-t>
              </template>
            </i18n-t>
            <p class="mb-0">{{ $t(cardCaptions.description_3_path) }}</p>
          </template>
          <template v-else>
            <i18n-t :keypath="cardCaptions.description_2_path" tag="p">
              <template #description_2_subtext1>
                <span class="font-weight-bold black">
                  {{ $t(cardCaptions.description_2_subtext1_path) }}
                </span>
              </template>
              <template #description_2_subtext2>
                <span class="font-weight-bold black">
                  {{ $t(cardCaptions.description_2_subtext2_path) }}
                </span>
              </template>
              <template #description_2_subtext3>
                <span class="font-weight-bold black">
                  {{ $t(cardCaptions.description_2_subtext3_path) }}
                </span>
              </template>
              <template #description_2_subtext4>
                <span class="font-weight-bold black">
                  {{ $t(cardCaptions.description_2_subtext4_path) }}
                </span>
              </template>
            </i18n-t>
            <i18n-t :keypath="cardCaptions.description_3_path"
                    tag="p"
                    class="mb-0"
            >
              <template #description_3_subtext1>
                <span class="font-weight-bold black">
                  {{ $t(cardCaptions.description_3_subtext1_path) }}
                </span>
              </template>
              <template #description_3_subtext2>
                <span class="font-weight-bold black">
                  {{ $t(cardCaptions.description_3_subtext2_path) }}
                </span>
              </template>
              <template #description_3_subtext3>
                <span class="font-weight-bold black">
                  {{ $t(cardCaptions.description_3_subtext3_path) }}
                </span>
              </template>
              <template #description_3_linktext>
                <SLink appearance="b-link"
                       class="font-weight-normal"
                       :href="$t(cardCaptions.description_3_link_path)"
                >
                  {{ $t(cardCaptions.description_3_linktext_path) }}
                </SLink>
              </template>
            </i18n-t>
          </template>
        </div>
      </div>
    </template>

    <template #left-action>
      <b-button
        variant="link"
        class="f-14 font-weight-normal"
        data-cy="left-action"
        :class="{ 'text-right': isConfigureInfoCard, 'mb-3': isConfigureInfoCard && rightActionText }"
        @click="$emit('left-action')"
      >
        {{ leftActionText }}
      </b-button>
    </template>

    <template v-if="rightActionText" #right-action>
      <!-- eslint-disable-next-line sdui/require-focus-restore-on-disabled-button -->
      <b-button
        id="content-move-card-right-action"
        variant="primary"
        class="f-14 font-weight-normal ml-5"
        data-cy="right-action"
        :disabled="rightActionDisabled"
        :class="{ 'spinner-btn': rightActionDisabled }"
        @click="$emit('right-action')"
      >
        {{ rightActionText }}
      </b-button>
    </template>
  </sdui-alert>
</template>

<script>
import SduiAlert from 'src/components/miscellaneous/ui/common/SduiAlert.vue'

export default {
  name: 'SduiContentMoveCard',
  components: {
    SduiAlert,
  },

  props: {
    title: {
      type: String,
      required: true,
    },

    description: {
      type: String,
      default: '',
    },

    leftActionText: {
      type: String,
      required: true,
    },

    rightActionText: {
      type: String,
      default: '',
    },

    rightActionDisabled: {
      type: Boolean,
      default: false,
    },

    isConfigureInfoCard: {
      type: Boolean,
      default: false,
    },

    hasSuggestedChannel: {
      type: Boolean,
      default: false,
    },

    cardCaptions: {
      type: Object,
      default: () => ({}),
    },
  },

  emits: ['left-action', 'right-action'],
}
</script>
